import StaffInformation from '../views/human/StaffInformation.vue'
import LeaveManagement from '../views/human/LeaveManagement.vue'
import AttendanceManagement from '../views/human/AttendanceManagement.vue'
import PerformanceManagement from '../views/human/PerformanceManagement.vue'
import EventManagement from '../views/human/EventManagement.vue'
import CompensationBenefits from '../views/human/CompensationBenefits.vue'
import EngagementFeedback from '../views/human/EngagementFeedback.vue'
import OffBoarding from '../views/human/OffBoarding.vue'
import PolicyDocuments from '../views/human/PolicyDocuments.vue'


export default [
    // human: [ "StaffInformation", "LeaveManagement", "AttendanceManagement", "PerformanceManagement", 
    // "EventManagement", "CompensationBenefits", "EngagementFeedback", "OffBoarding", "PolicyDocuments", ],
    {
        path: '/human/information',
        name: 'StaffInformation',
        component: StaffInformation
    },
    {
        path: '/human/leave',
        name: 'LeaveManagement',
        component: LeaveManagement
    },
    {
        path: '/human/attendance',
        name: 'AttendanceManagement',
        component: AttendanceManagement
    },
    {
        path: '/human/performance',
        name: 'PerformanceManagement',
        component: PerformanceManagement
    },
    {
        path: '/human/events',
        name: 'EventManagement',
        component: EventManagement
    },
    {
        path: '/human/compensation',
        name: 'CompensationBenefits',
        component: CompensationBenefits
    },
    {
        path: '/human/engagement',
        name: 'EngagementFeedback',
        component: EngagementFeedback
    },
    {
        path: '/human/exit',
        name: 'OffBoarding',
        component: OffBoarding
    },
    {
        path: '/human/policies',
        name: 'PolicyDocuments',
        component: PolicyDocuments
    },
];